export default {
      id: "invoicing-usage",
      viewBox: "0 0 27.383 27.009",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#invoicing",
      toString: function () {
        return this.url;
      }
    }